export default __webpack_public_path__ + "static/media/team_member8.fe9b2c2f.png";